module.exports = __webpack_public_path__ + "static/media/closemenu.533988ba.svg";